export default "__VITE_ASSET__D5QLuk7C__"